module.exports = __webpack_public_path__ + "media/images/health_team_invite_banner-27b1bc8f.svg";